/* ========================================================================== *\
   GLOBAL
\* ========================================================================== */


/* -------------------------------------------------------------------------- *\
   SUBMIT ON SELECT CHANGE
\* -------------------------------------------------------------------------- */

document.querySelectorAll('.js-select-submit').forEach((element) => {
    element.addEventListener('change', () => {
        element.closest('form').submit();
    });
});